export default __webpack_public_path__ + "img/industrial-engineer-programming-machine-control.11be0469.jpg";